import React from "react";
import {formatSimmsDateTime} from "../commonmethod/CommonMethod";

export function getNestedValue(obj, path, short) {
    if (path == null || path === "") return "";
    const pathStr = String(path);
    const value = pathStr.split(".").reduce((acc, part) => {
        if (Array.isArray(acc)) {
            if (short) {
                const [firstCount, unit] = short;
                const first = acc
                    .slice(0, firstCount)
                    .map((item) => item[part])
                    .join(", ");
                const count = acc.length - firstCount;
                return count > 0 ? `${first} 외 ${count}${unit}` : first;
            }
            return acc.map((item) => item[part]).join(", ");
        }
        return acc && acc[part];
    }, obj);
    return value ?? "";
}

function formatDateValue(value) {
    return formatSimmsDateTime(value);
}

function formatScalar(value) {
    if (value == null || value === "") return "";
    if (typeof value === "object") {
        return value.name ?? value.title ?? value.label ?? "";
    }
    return String(value);
}

export function buildLinkedGridColumnLayout(columns = []) {
    const total = columns.reduce((sum, col) => sum + (Number(col.width) || 120), 0) || 1;
    return columns.map((col) => {
        const width = Number(col.width) || 120;
        return {
            ...col,
            minWidth: Math.max(72, width),
            gridWidth: `${Math.max(8, Math.round((width / total) * 10000) / 100)}fr`,
        };
    });
}

export function buildLinkedGridTemplate(columns = [], options = {}) {
    const {withAction = false} = options;
    const base = columns.map((col) => `minmax(${col.minWidth}px, ${col.gridWidth})`).join(" ");
    return withAction ? `${base} 28px` : base;
}

export function resolvePrimaryColumnKey(columns = []) {
    const found = columns.find((col) => {
        const key = String(col.key ?? col.field ?? "");
        const base = key.split("|")[0].split(".")[0];
        return base === "title" || base === "name" || key.endsWith(".name") || key.endsWith(".title");
    });
    return found?.key ?? columns[0]?.key;
}

export function isDetailColumn(col) {
    const key = String(col.key ?? col.field ?? "");
    return key.includes("rawValue") || key.includes("updateValue") || (col.width ?? 0) >= 280;
}

export function formatLinkedCellText(row, col) {
    const field = col.key;
    if (field?.includes("|")) {
        const parts = field.split("|");
        return parts
            .map((part, index) => {
                const label = col.label?.[index] ?? "";
                const raw = getNestedValue(row, part);
                const text =
                    typeof raw === "string" && /^\d{4}-\d{2}-\d{2}/.test(raw)
                        ? formatDateValue(raw)
                        : formatScalar(raw);
                return text ? `${label}${text}` : "";
            })
            .filter(Boolean)
            .join(" · ");
    }

    const raw = getNestedValue(row, field, col.short);
    if (typeof raw === "string" && /^\d{4}-\d{2}-\d{2}/.test(raw)) {
        return formatDateValue(raw);
    }
    return formatScalar(raw);
}

function isCompactLinkedColumn(col) {
    const key = String(col?.key ?? "");
    return col?.type === "dateArray" || key.includes("|");
}

export function renderLinkedGridCell(row, col, rowIndex) {
    if (isCompactLinkedColumn(col)) {
        return formatLinkedCellText(row, col) || "\u00A0";
    }

    if (typeof col.render === "function") {
        const value = getNestedValue(row, col.key, col.short);
        try {
            const node = col.render({
                row,
                value,
                columnKey: col.key,
                rowIndex,
                stopRowClick: () => {},
            });
            if (node != null) return node;
        } catch {
            /* fall through */
        }
    }

    const field = col.key;
    const raw = getNestedValue(row, field, col.short);
    if (typeof raw === "string" && /^\d{4}-\d{2}-\d{2}/.test(raw)) {
        return formatDateValue(raw);
    }
    return formatScalar(raw) || "\u00A0";
}
